import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { Loader } from "@googlemaps/js-api-loader";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import '../styles/unidade.min-2.css';
import Banner11Desk from '../assets/pilates-criciuma-banner1-desk.png';
import Banner12Desk from '../assets/pilates-criciuma-banner2-desk.png';
import Banner13Desk from '../assets/pilates-criciuma-banner3-desk.png';

import Banner1 from '../assets/pilates-criciuma-banner1-mobile.png';
import Banner2 from '../assets/pilates-criciuma-banner2-mobile.png';
import Banner3 from '../assets/pilates-criciuma-banner3-mobile.png';
import Banner4 from '../assets/pilates-criciuma-banner4-mobile.png';

import TrainWithUs3 from '../assets/pilates-criciuma-trainWithUs3.png';
import LogoBranca from '../assets/logo_branca.png';
import Studio1 from '../assets/Studio1.png';
import Studio2 from '../assets/Studio2.png';
import Studio3 from '../assets/Studio3.png';
import Studio4 from '../assets/Studio4.png';

import Equipe1 from '../assets/Equipe1.png';

const Slider = React.lazy(() => import("react-slick"));

export default function Home() {
    const settings = { 
        infinite: true,
        slidesToShow: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToScroll: 1,
        arrows: false,
        swipe: true
    };

    const settings2 = {
        infinite: true,
        slidesToShow: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToScroll: 1,
        arrows: true,
        swipe: true
    };

    const settings3 = {
        infinite: true,
        slidesToShow: 1,
        dots: false,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToScroll: 1,
        arrows: true,
        swipe: true 
    };

    const multipleitems = {
        infinite: true,
        slidesToShow: 1,
        dots: true,
        arrow: false,
        autoplay: true,
        autoplaySpeed: 8000,
        slidesToScroll: 1
    };

    const mapRef = useRef(null);
    useEffect(() => {
        const loader = new Loader({
            apiKey: "AIzaSyCNPMxWfe-QyWIHivqJMEq5vN5Me8jNBOM",
            version: "weekly",
            libraries: ["marker"], // necessário para AdvancedMarkerElement
        });

        loader.load().then(() => {
            const local = { lat: -28.6831779, lng: -49.3769547 };
            const map = new window.google.maps.Map(mapRef.current, {
                zoom: 15,
                center: local,
                mapId: "DEMO_MAP_ID",
        });

        new window.google.maps.marker.AdvancedMarkerElement({
                position: local,
                map: map,
                title: "Localização aqui!",
            });
        });
    }, []);

  return (
    <>
        <Helmet>
            <title>OsteoVitta Pilates - Criciúma</title>
            <link rel="canonical" href="https://www.osteovitta.com.br/" />
            <meta name="description" content="Descubra os benefícios do Pilates na OsteoVitta em Criciúma" />
        </Helmet>

        <main>
            <section className="pilates-banner-main">
                <Slider {...settings} className="sliderBanner">
                        <div>
                            <div className="pilates-banner-main-container">
                                <img src={Banner11Desk} alt="Pilates Centro Criciúma OsteoVitta" />
                                <div className="pilates-banner-main-container--absolute">
                                    <h2 className="pilates-banner-main-title">
                                        Pilates: <span>Qualidade de Vida</span>
                                    </h2>
                                    <a
                                        href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%c3%a1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%c3%a7%c3%b5es%20sobre%20aulas%20de%20Pilates"
                                        target="_blank"
                                        rel="noreferrer"
                                        className="pilates-btn-red pilates-banner-main-link"
                                    >
                                        COMECE AGORA MESMO
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="pilates-banner-main-container">
                                <img src={Banner12Desk} alt="Pilates Centro Criciúma OsteoVitta" />
                                <div className="pilates-banner-main-container--absolute">
                                <h2 className="pilates-banner-main-title">
                                    Pilates: <span>Saúde e Movimento</span>
                                </h2>
                                <a
                                    href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%c3%a1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%c3%a7%c3%b5es%20sobre%20aulas%20de%20Pilates"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="pilates-btn-red pilates-banner-main-link"
                                >
                                    AGENDE SUA AULA
                                </a>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div className="pilates-banner-main-container">
                                <img src={Banner13Desk} alt="Pilates Centro Criciúma OsteoVitta" />
                                <div className="pilates-banner-main-container--absolute">
                                <h2 className="pilates-banner-main-title">
                                    Pilates: <span>Controle, Força e Leveza</span>
                                </h2>
                                <a
                                    href="https://api.whatsapp.com/send?phone=554891106910&amp;text=Ol%c3%a1,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informa%c3%a7%c3%b5es%20sobre%20aulas%20de%20Pilates"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="pilates-btn-red pilates-banner-main-link"
                                >
                                    COMECE AGORA MESMO
                                </a>
                                </div>
                            </div>
                        </div>
  
                </Slider>
            </section>
    

            <section className="pilates-banner-main--mobile">
                <Slider {...settings} className="sliderBanner">
                    <div>
                        <div className="pilates-banner-main-container">
                            <img src={Banner1} alt="Pilates Centro Criciúma OsteoVitta"/>
                            <div className="pilates-banner-main-container--absolute">
                                <h2 className="pilates-banner-main-title">
                                    Pilates, <br/>Qualidade de Vida
                                </h2>
                                <a
                                    href="https://api.whatsapp.com/send?phone=554891106910&text=Olá,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20aulas%20de%20Pilates"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="pilates-btn-red pilates-banner-main-link"
                                >
                                    COMECE AGORA MESMO
                                </a>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="pilates-banner-main-container">
                            <img src={Banner2} alt="Pilates Centro Criciúma OsteoVitta"/>
                            <div className="pilates-banner-main-container--absolute">
                                <h2 className="pilates-banner-main-title">
                                    TREINO <br/>PERSONALIZADO
                                </h2>
                                <a
                                    href="https://api.whatsapp.com/send?phone=554891106910&text=Olá,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20aulas%20de%20Pilates"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="pilates-btn-red pilates-banner-main-link"
                                >
                                    AGENDE SUA AULA
                                </a>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="pilates-banner-main-container">
                            <img src={Banner3} alt="Pilates Centro Criciúma OsteoVitta" />
                            <div className="pilates-banner-main-container--absolute">
                            <h2 className="pilates-banner-main-title">
                                AMBIENTE<br/>ACOLHEDOR
                            </h2>
                            <a
                                href="https://api.whatsapp.com/send?phone=554891106910&text=Olá,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20aulas%20de%20Pilates"
                                target="_blank"
                                rel="noreferrer"
                                className="pilates-btn-red pilates-banner-main-link"
                            >
                                COMECE AGORA MESMO
                            </a>
                            </div>
                        </div>
                    </div>

                    <div>
                        <div className="pilates-banner-main-container">
                            <img src={Banner4} alt="Pilates Centro Criciúma OsteoVitta" />
                            <div className="pilates-banner-main-container--absolute">
                            <h2 className="pilates-banner-main-title">
                            ATENDIMENTO POR<br/>FISIOTERAPEUTAS
                            </h2>
                            <a
                                href="https://api.whatsapp.com/send?phone=554891106910&text=Olá,%20estava%20no%20site%20e%20gostaria%20de%20mais%20informações%20sobre%20aulas%20de%20Pilates"
                                target="_blank"
                                rel="noreferrer"
                                className="pilates-btn-red pilates-banner-main-link"
                            >
                                AGENDE SUA AULA
                            </a>
                            </div>
                        </div>
                    </div>
                </Slider>
            </section>

            <section className="pilates-advantage multiple-items">
                <Slider {...multipleitems} className="sliderBanner">
                    <div>
                        <ul className="pilates-advantage-list">

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_01">reduza o estresse</h2>
                                    <span className="pilates-advantage-subTitle">do dia a dia</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    Desenvolva o autocontrole por meio da respiração e do movimento consciente, e aprenda a lidar melhor com situações de estresse, ansiedade e tensão.
                                </span>
                            </li>

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_02">Alivia dores</h2>
                                    <span className="pilates-advantage-subTitle">do corpo</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    Recomendado por especialistas, o Pilates é eficaz no tratamento de dores crônicas, especialmente na coluna e nas articulações, promovendo alívio e mais qualidade de vida.
                                </span>
                            </li>

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_03">Fortalece a musculatura</h2>
                                    <span className="pilates-advantage-subTitle">profunda e superficial</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    O Pilates ativa e fortalece todo o corpo, com foco especial nos músculos profundos, 
                                    essenciais para postura, estabilidade e equilíbrio.
                                </span>
                            </li>

                        </ul>
                    </div>    

                    <div>
                        <ul className="pilates-advantage-list">
                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_04">Melhora a respiração </h2>
                                    <span className="pilates-advantage-subTitle">e a capacidade pulmonar</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    O Pilates estimula a musculatura respiratória e ensina a respirar de forma consciente e eficiente, 
                                    aumentando a oxigenação e o controle da respiração.
                                </span>
                            </li>

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_05">Corrige a postura</h2>
                                    <span className="pilates-advantage-subTitle">e aumenta a flexibilidade</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    Com foco no alinhamento corporal e na mobilidade, o Pilates melhora a postura, previne lesões e 
                                    contribui para um corpo mais jovem e funcional ao longo do tempo.
                                </span>
                            </li>

                            <li className="pilates-advantage-item">
                                <div className="pilates-advantage-item-text-container">
                                    <h2 className="pilates-advantage-title pilates-advantage-title_06">Melhora A CONCENTRAÇÃO</h2>
                                    <span className="pilates-advantage-subTitle">atenção e foco</span>
                                </div>
                                <span className="pilates-advantage-text">
                                    Com movimentos precisos e controlados, o Pilates estimula a conexão entre corpo e mente, 
                                    ajudando você a manter o foco e a concentração, sem se distrair com estímulos externos ou internos.
                                </span>
                            </li>
                        </ul>
                    </div>
                </Slider>
            </section>

            <section className="pilates-advantage pilates-advantage-desktop">
                    <ul className="pilates-advantage-list">

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_01">reduza o estresse</h2>
                                <span className="pilates-advantage-subTitle">do dia a dia</span>
                            </div>
                            <span className="pilates-advantage-text">
                                Desenvolva o autocontrole por meio da respiração e do movimento consciente, 
                                e aprenda a lidar melhor com situações de estresse, ansiedade e tensão.
                            </span>
                        </li>

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_02">Alivia dores</h2>
                                <span className="pilates-advantage-subTitle">do corpo</span>
                            </div>
                            <span className="pilates-advantage-text">
                                Recomendado por especialistas, o Pilates é eficaz no tratamento de dores crônicas, 
                                especialmente na coluna e nas articulações, promovendo alívio e mais qualidade de vida.
                            </span>
                        </li>

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_03">Fortalece a musculatura</h2>
                                <span className="pilates-advantage-subTitle">profunda e superficial</span>
                            </div>
                            <span className="pilates-advantage-text">
                                O Pilates ativa e fortalece todo o corpo, com foco especial nos músculos profundos, 
                                essenciais para postura, estabilidade e equilíbrio.
                            </span>
                        </li>

                    </ul>

                    <ul className="pilates-advantage-list">
                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_04">Melhora a respiração</h2>
                                <span className="pilates-advantage-subTitle">e a capacidade pulmonar</span>
                            </div>
                            <span className="pilates-advantage-text">
                                O Pilates estimula a musculatura respiratória e ensina a respirar de forma consciente e eficiente, 
                                aumentando a oxigenação e o controle da respiração.
                            </span>
                        </li>

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_05">Corrige a postura</h2>
                                <span className="pilates-advantage-subTitle">e aumenta a flexibilidade</span>
                            </div>
                            <span className="pilates-advantage-text">
                                Com foco no alinhamento corporal e na mobilidade, o Pilates melhora a postura, 
                                previne lesões e contribui para um corpo mais jovem e funcional ao longo do tempo.
                            </span>
                        </li>

                        <li className="pilates-advantage-item">
                            <div className="pilates-advantage-item-text-container">
                                <h2 className="pilates-advantage-title pilates-advantage-title_06">Melhora A CONCENTRAÇÃO</h2>
                                <span className="pilates-advantage-subTitle">atenção e foco</span>
                            </div>
                            <span className="pilates-advantage-text">
                                Com movimentos precisos e controlados, o Pilates estimula a conexão entre corpo e mente, 
                                ajudando você a manter o foco e a concentração, sem se distrair com estímulos externos ou internos.
                            </span>
                        </li>

                    </ul>
            </section>

            <section className="pilates-advantage pilates-advantage-tablet">
                <ul className="pilates-advantage-list">

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_01">reduza o estresse</h2>
                            <span className="pilates-advantage-subTitle">do dia a dia</span>
                        </div>
                        <span className="pilates-advantage-text">
                            Desenvolva o autocontrole por meio da respiração e do movimento consciente, 
                            e aprenda a lidar melhor com situações de estresse, ansiedade e tensão.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_02">Alivia dores</h2>
                            <span className="pilates-advantage-subTitle">do corpo</span>
                        </div>
                        <span className="pilates-advantage-text">
                            Recomendado por especialistas, o Pilates é eficaz no tratamento de dores crônicas, 
                            especialmente na coluna e nas articulações, promovendo alívio e mais qualidade de vida.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_03">Fortalece a musculatura</h2>
                            <span className="pilates-advantage-subTitle">profunda e superficial</span>
                        </div>
                        <span className="pilates-advantage-text">
                            O Pilates ativa e fortalece todo o corpo, com foco especial nos músculos profundos, 
                            essenciais para postura, estabilidade e equilíbrio.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_04">Melhora a respiração</h2>
                            <span className="pilates-advantage-subTitle">e a capacidade pulmonar</span>
                        </div>
                        <span className="pilates-advantage-text">
                            O Pilates estimula a musculatura respiratória e ensina a respirar de forma consciente e eficiente, 
                            aumentando a oxigenação e o controle da respiração.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_05">Corrige a postura</h2>
                            <span className="pilates-advantage-subTitle">e aumenta a flexibilidade</span>
                        </div>
                        <span className="pilates-advantage-text">
                            Com foco no alinhamento corporal e na mobilidade, o Pilates melhora a postura, 
                            previne lesões e contribui para um corpo mais jovem e funcional ao longo do tempo.
                        </span>
                    </li>

                    <li className="pilates-advantage-item">
                        <div className="pilates-advantage-item-text-container">
                            <h2 className="pilates-advantage-title pilates-advantage-title_06">Melhora A CONCENTRAÇÃO</h2>
                            <span className="pilates-advantage-subTitle">atenção e foco</span>
                        </div>
                        <span className="pilates-advantage-text">
                            Com movimentos precisos e controlados, o Pilates estimula a conexão entre corpo e mente, 
                            ajudando você a manter o foco e a concentração, sem se distrair com estímulos externos ou internos.
                        </span>
                    </li>

                </ul>
            </section>

            <section className="pilates-trainWithUs">
                <div className="pilates-trainWithUs-container">
                    <h3 className="pilates-trainWithUs-title">O QUE É PILATES?</h3>

                    <div className="pilates-trainWithUs-content">
                        <p className="pilates-trainWithUs-content-text">
                            Pilates é uma prática corporal criada por Joseph Pilates que busca o equilíbrio entre força, 
                            flexibilidade e consciência corporal. O método é baseado em movimentos controlados, 
                            respiração e alinhamento postural, promovendo saúde e bem-estar de forma completa.
                        </p>

                        <p className="pilates-trainWithUs-content-text">
                            É uma atividade acessível a todos: crianças, gestantes, idosos, pessoas em reabilitação ou simplesmente 
                            quem busca mais qualidade de vida no dia a dia. 
                            Todos podem praticar Pilates — no seu ritmo e de acordo com suas necessidades.
                        </p>

                        <p className="pilates-trainWithUs-content-text">
                            Contamos com instrutores capacitados para garantir a execução correta dos movimentos, 
                            sempre respeitando seu corpo e incentivando a evolução contínua. Oferecemos aulas com duração de 30 ou 50 minutos, 
                            pensadas para que você aproveite cada segundo. Nosso propósito é simples: ser o melhor momento do seu dia!
                        </p>
                    </div>

                </div>

                <div className="pilates-trainWithUs-content-img">
                    <img className="pilates-trainWithUs-img" src={TrainWithUs3} alt="Pilates Centro Criciúma OsteoVitta"/>
                </div>
            </section>

            <section className="pilates-rating">
                <div className="pilates-rating-container">
                    <div className="pilates-rating-text">
                    <span className="pilates-rating-text-subTitle">
                        Depoimentos de quem treina na
                    </span>
                    <h3 className="pilates-rating-text-title">OsteoVitta Pilates</h3>
                    </div>

                    <div className="pilates-rating-user">
                    <Slider {...settings2}>
                        {/* Slide 1 */}
                        <div>
                        <div className="pilates-rating-user-header">
                            <img
                            className="pilates-rating-user-image"
                            src={LogoBranca}
                            alt="Pilates Centro Criciúma OsteoVitta"
                            />
                            <div className="pilates-rating-user-container">
                            <span className="pilates-rating-user-name">Ana Koche</span>
                            <span className="pilates-rating-user-client">cliente</span>
                            </div>
                        </div>
                        <div className="pilates-rating-user-body">
                            <p className="pilates-rating-user-depositions">
                            ambiente acolhedor, ótimas profissionais! super recomendo pois
                            além de saúde é uma terapia!
                            </p>
                            <div className="pilates-rating-user-star"></div>
                        </div>
                        </div>

                        {/* Slide 2 */}
                        <div>
                        <div className="pilates-rating-user-header">
                            <img
                            className="pilates-rating-user-image"
                            src={LogoBranca}
                            alt="Pilates Centro Criciúma OsteoVitta"
                            />
                            <div className="pilates-rating-user-container">
                            <span className="pilates-rating-user-name">Carolini Ronsani</span>
                            <span className="pilates-rating-user-client">cliente</span>
                            </div>
                        </div>
                        <div className="pilates-rating-user-body">
                            <p className="pilates-rating-user-depositions">
                            Excelente atendimento profissional com a devida atenção para
                            cada aluno. O pilates melhorou minha qualidade de vida e a
                            professora nos incentiva a cada aula!
                            </p>
                            <div className="pilates-rating-user-star"></div>
                        </div>
                        </div>

                        {/* Slide 3 */}
                        <div>
                        <div className="pilates-rating-user-header">
                            <img
                            className="pilates-rating-user-image"
                            src={LogoBranca}
                            alt="Pilates Centro Criciúma OsteoVitta"
                            />
                            <div className="pilates-rating-user-container">
                            <span className="pilates-rating-user-name">Andressa Souza Dias</span>
                            <span className="pilates-rating-user-client">cliente</span>
                            </div>
                        </div>
                        <div className="pilates-rating-user-body">
                            <p className="pilates-rating-user-depositions">
                            Associar Pilates e musculação me ajudou muito, consegui ter
                            uma maior ativação do abdômen e menos dores na lombar com os
                            exercícios específicos! Muito bom!!
                            </p>
                            <div className="pilates-rating-user-star"></div>
                        </div>
                        </div>
                    </Slider>
                    </div>
                </div>
            </section>


            <section className="pilates-aberta-class-container">
                <h2 className="pilates-aberta-title pilates-aberta-class-title">
                    <span>Pilates no Centro de Criciúma</span>
                </h2>

                <p className="pilates-aberta-class-text">
                    Descubra todos os benefícios do Pilates em um ambiente confortável e bem localizado. A OsteoVitta Pilates está<br className="mobile-hide-br"/>
                    no <span style={{fontWeight: '800'}}> Centro de Criciúma</span>, próxima ao Supermercado Bistekinho, e oferece agendamento 100% online <br className="mobile-hide-br"/> 
                    pelo WhatsApp para que você confira com facilidade o dia e o horário para suas aulas.
                </p>

                <div className="pilates-aberta-class-unidade">
                    <div className="pilates-aberta-class-unidade--flex">
                        <div className="pilates-aberta-class-unidade-map">
                            <a href="https://maps.app.goo.gl/j4cabYTfpQim92bi7" target="_blank" rel="noreferrer">
                                <div ref={mapRef} id="map" className="leaflet-map-container"></div>
                            </a>

                            <div
                                className="pilates-aberta-class-unidades-map-infos"
                                itemProp="address"
                                itemScope
                                itemType="http://schema.org/PostalAddress"
                            >
                                <address>
                                <span itemProp="streetAddress">Rua Pedro Beneton, 335, Sala 02 - Centro</span>
                                <br />
                                <span itemProp="addressLocality">Criciúma</span>,
                                <span itemProp="addressRegion">SC</span>.
                                </address>
                            </div>
                        </div>

                        <div className="pilates-aberta-img-slider">
                            <Slider {...settings3} className="one-time">
                                <div><img src={Studio1} alt="Pilates Centro Criciúma OsteoVitta" /></div>
                                <div><img src={Studio2} alt="Pilates Centro Criciúma OsteoVitta" /></div>
                                <div><img src={Studio3} alt="Pilates Centro Criciúma OsteoVitta" /></div>
                                <div><img src={Studio4} alt="Pilates Centro Criciúma OsteoVitta" /></div>
                                <div><img src={Equipe1} alt="Pilates Centro Criciúma OsteoVitta" /></div>
                            </Slider>

                            <div className="pilates-aberta-img-slider-text">
                            </div>
                            
                        </div>

                    </div>

                </div>
            </section>

        </main>
    </>
  );
}